import { render, staticRenderFns } from "./MaterialLinkPop.vue?vue&type=template&id=4e3e2e96&scoped=true"
import script from "./MaterialLinkPop.vue?vue&type=script&lang=ts"
export * from "./MaterialLinkPop.vue?vue&type=script&lang=ts"
import style0 from "./MaterialLinkPop.vue?vue&type=style&index=0&id=4e3e2e96&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3e2e96",
  null
  
)

export default component.exports